module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "fmh"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "fig0"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01"
    }
  }, [_vm._v("Chapter 1 — The Test Subject")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap02"
    }
  }, [_vm._v("Chapter 2 — The Village Witch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 — You Are Supposed To Be Scary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 — The Witch Creator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 — The Terror Of Ivanov")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 — Trouble Personified")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 — She Would Never!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 — A Witch? More Like A Demon From Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 — Meanwhile, Back At The Ranch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 — Whatever …. (Rolling Eyes)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 — Be Afraid, Be Very Afraid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 — Wolves And A Blizzard. This Is Russia After All")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 — Letting The Cat Out Of The Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 — Cookies and Goggles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 — Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 — Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 69
// module chunks = 0